import { Component, OnInit } from '@angular/core';
import { Color } from 'src/app/config/color';
import { Tile } from 'src/app/submodules/angular-ui-common/base-types';
import { CommonIcon } from 'src/app/submodules/angular-ui-common/icon';
import { TileSetSettings } from 'src/app/submodules/angular-ui-common/tile-set/tile-set.component';

@Component({
  selector: 'app-home-footer',
  templateUrl: './home-footer.component.html',
  styleUrls: ['./home-footer.component.scss']
})
export class HomeFooterComponent {

  settings: TileSetSettings = {
    layout: 1,
    spacing: '10px',
    width: '1300px',
    alignment: 'center',
    margin: '0 0 5px 0',
    tileSettings: {
      fontSize: '18px',
      fontColor: Color.main,
      border: "none",
      width: '270px',
      height: '120px',
      icon: {
        fontColor: Color.auxiliary,
        size: '60px'
      },
      label : {
        fontSize: '16px',
        margin: '8px 0 0 0',
        fontColor: Color.main,
      },
      label2 : {
        fontSize: '18px',
        fontColor: Color.main,
      },
    }
  };

  tiles : Tile[] = [
    { id: 1,
      icon: CommonIcon.mapMarker,
      label: "Vieni a trovarci",
      label2: "<b>Via San Tommaso 12, Torino</b>",
      navigable: true,
      action: this.goToMaps.bind(this)
    },
    { id: 2, 
      icon: CommonIcon.at,
      label: "Scrivici",
      label2: "<b>info@performancetraininglab.it</b>",
      navigable: true,
      action: this.sendEmail.bind(this)
    },
    { id: 3, 
      icon: CommonIcon.phone,
      label: "Chiamaci",
      label2: "‎<b>011 264 2124</b>",
      navigable: true,
      action: this.phone.bind(this)
    },
    { id: 4, 
      icon: CommonIcon.instagram,
      label: "Seguici",
      label2: "<b>@performancetraininglab</b>",
      navigable: true,
      action: this.goToInstagramPage.bind(this)
    }
  ]

  constructor() { }

  goToInstagramPage() {
    window.location.href = "https://www.instagram.com/performancetraininglab/"
  } 

  goToMaps() {
    window.location.href = "https://www.google.com/maps/place/Via+S.+Tommaso,+12,+10122+Torino+TO/@45.070898,7.679386,17z/data=!3m1!4b1!4m5!3m4!1s0x47886d72276bcf21:0xdbe762eb88a57866!8m2!3d45.070898!4d7.68158"
  }
  
  sendEmail() {
    window.location.href = "mailto:info@performancetraininglab.it"
  } 

  phone() {
    window.location.href = "tel:0112642124"
  } 

}
